import * as yup from 'yup';
import useValidators from 'components/Form/validations/useValidators';

const useValidationSchema = (keyValues: { keywords: string[]; contents: string[] }) => {
  const { required, unique } = useValidators();
  const StudyReportTemplateFormSchema = yup.object().shape({
    keyword: unique(required(yup.string()), keyValues.keywords),
    content: unique(required(yup.string().nullable()), keyValues.contents),
  });

  return { StudyReportTemplateFormSchema };
};

export default useValidationSchema;
